import { useTranslation, Trans } from 'react-i18next';
import { ProFeatureCard } from '@/features/landing/components/ProFeatureCard';

const proFeatures = [
  { titleKey: 'pro.customDomains.title', descriptionKey: 'pro.customDomains.description' },
  { titleKey: 'pro.moreSites.title', descriptionKey: 'pro.moreSites.description' },
  { titleKey: 'pro.analytics.title', descriptionKey: 'pro.analytics.description' },
];

export function ProSection() {
  const { t } = useTranslation();

  return (
    <section className="py-20 px-4 bg-black/10">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl mb-4">{t('pro.title')}</h2>
          <p className="text-muted-foreground text-sm max-w-2xl mx-auto">
            {t('pro.description')}
          </p>
        </div>

        {/* Pro Features Grid */}
        <div className="grid md:grid-cols-2 gap-x-16 gap-y-8 max-w-4xl mx-auto">
          {proFeatures.map((feature, index) => (
            <ProFeatureCard
              key={index}
              titleKey={feature.titleKey}
              descriptionKey={feature.descriptionKey}
            />
          ))}
        </div>

        {/* Pricing */}
        <div className="text-center mt-16">
          <p className="text-muted-foreground text-sm mb-2">
            <Trans i18nKey="pro.pricing" components={{ price: <span className="text-primary" /> }} />
          </p>
        </div>
      </div>
    </section>
  );
}
